<template>
    <div class="us_app">
        <section class="user_section">
            <div class="title jc">
                <h2>QnA</h2>
            </div>
                                  
            <article class="view cmnity">
                <!-- QnA  -->
                <div class="cmnity_detail">
                    <div class="title_box">
                        <h3>{{qnaInfo.qna_title}} <i class="icon icon_lock" v-if="qnaInfo.scret_yn =='Y'"></i></h3>
                        <div class="info_box">
                            <p>작성자 <span>{{qnaInfo.doctor_nm}}</span></p>
                        </div>
                    </div>
                    <pre class="desc">{{qnaInfo.question_contents}}</pre>
                    <div class="title_box" v-if="qnaInfo.qna_status == 'RS'">
                        <h3 class="brown">답변</h3>
                    </div>
                    <pre class="desc" v-if="qnaInfo.qna_status == 'RS'">{{qnaInfo.response_contents}}</pre>
                    <div class="bottom_box">
                        <button 
                            class="btn btn_md btn_darkbrown"
                            @click="$router.push('/qna')"
                        >
                                목록
                        </button>
                    </div>
                </div>
            </article>
                       
        </section>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        props: ['id'],
        components: {
        },
        data () {
            return {
                navTitle: ['커뮤니티', 'QnA'],
                qnaInfo : {}
            }
        },
        mounted() {
            this.fn_search();
        },
        methods : {
            fn_search(){

                let param = new Object();
                param.qnaSeq = this.id;

                axios
                    .post("/api/user/board/getQnaDetail", param)
                    .then((res) => {

                        this.qnaInfo = res.data.qnaInfo;

                        console.log("@@@@ qnaList : %o",this.qnaInfo);                      

                    })
                    .catch((err) => console.log(err));
            },
        }
    }
</script>